import { storage } from '../firebase_config';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

export const uploadHtml = async (file: File, folder: string = 'notices'): Promise<{ folderName: string }> => {
  try {
    const maxSize =  50 * 1024 * 1024;
    if (file.size > maxSize) {
      throw new Error('파일 크기가 50MB를 초과합니다.');
    }

    const allowedTypes = [
      'application/zip',
      'application/x-zip-compressed',
      'multipart/x-zip',
      'application/x-compressed',
    ];
    if (!allowedTypes.includes(file.type) && !file.name.endsWith('.zip')) {
      throw new Error('지원하지 않는 ZIP 형식입니다.');
    }

    const timestamp = Date.now();
    const fileName = `${folder}/${timestamp}_${file.name}`;
    const storageRef = ref(storage, fileName);
    
    const snapshot = await uploadBytes(storageRef, file);
    // const zipUrl = await getDownloadURL(snapshot.ref);

    // Folder name must match what unzipFile function uses
    const folderName = fileName.replace('.zip', '');

    return { folderName };
  } catch (error) {
    throw error;
  }
}; 